var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Avatar as ChakraAvatar, } from "@chakra-ui/react";
import { Size } from "../../core/constants";
import { pick } from "../../core/utils";
export const AvatarSize = pick(Size, ["xs", "sm", "md", "lg", "xl", "xxl"]);
/**
 * The `Avatar` component is used to represent user, and displays the profile picture or initials.
 */
const Avatar = forwardRef((_a, ref) => {
    var { colorScheme, variantColor } = _a, rest = __rest(_a, ["colorScheme", "variantColor"]);
    const extraProps = {};
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const bg = scheme ? `${scheme}.500` : undefined;
    if (bg) {
        extraProps.bg = bg;
    }
    return React.createElement(ChakraAvatar, Object.assign({ ref: ref }, rest, extraProps));
});
Avatar.displayName = "Avatar";
export default Avatar;
//# sourceMappingURL=Avatar.js.map